import { BaseApi } from "./baseApi";
import axios from "axios";
export class ArticlesApi extends BaseApi {
    constructor() {
        super("article");
    }
    search(title, page, size, sort) {
        const params = {
            title: title,
            page: page.toString(),
            size: size.toString(),
            sort: sort.join(",")
        };
        return axios
            .get(`${this.baseEntity}/search`, { params })
            .then((response) => response.data);
    }
    /**
     * Получить связанные артиклы по id
     */
    getRelated(id) {
        return axios
            .get(`/rest/article/${id}/related`)
            .then((response) => response.data);
    }
}
